import * as Sentry from '@sentry/react';
import { AppRoutes } from './AppRoutes';

function App() {
  return <AppRoutes />;
}

export default Sentry.withProfiler(App);
